






































import {Component, Vue, Watch} from "vue-property-decorator";
import {Getter, Action} from "vuex-class";
import LoginForm from "@/components/Auth/LoginForm.vue";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import ForgotPasswordForm from "@/components/Auth/ForgotPasswordForm.vue";


const authNamespace: string = "auth";
@Component({
  components: {ForgotPasswordForm, DefaultLayout, LoginForm}
})
export default class ForgotPassword extends Vue {

  public name: string = "ForgotPassword";

  @Action('forgotPassword', {namespace: authNamespace}) forgotPassword: any;

  private error: any = null;
  private status: string = '';

  public onSubmit(data: object): void {

    this.forgotPassword(data).then((response: any) => {

      this.status = response.data.message;

    }).catch((error: any) => {

      // removed console_log
      this.error = error;

    });

  }

  private errormsg(): string {
    return this.error ? this.error.data.error : '';
  }

  mounted() {


  }

}
